import { createAction } from '/@/store/utils';

export const setField = createAction('CROP_MONITORING:SET_FIELD');
export const setRecommendation = createAction('CROP_MONITORING:SET_RECOMMENDATION');
export const setPlantingDate = createAction('CROP_MONITORING:SET_PLANTING_DATE');
export const setHumidity = createAction('CROP_MONITORING:SET_HUMIDITY');
export const setEnvironment = createAction('CROP_MONITORING:SET_ENVIRONMENT');
export const setDensity = createAction('CROP_MONITORING:SET_DENSITY');
export const setHybrid = createAction('CROP_MONITORING:SET_HYBRID');
export const setFertilizer = createAction('CROP_MONITORING:SET_FERTILIZER');
export const setFertilizerAmount = createAction('CROP_MONITORING:SET_FERTILIZER_AMOUNT');
export const setBtnDisabled = createAction('CROP_MONITORING:SET_BUTTON_DISABLED');
export const setCropProtectionProducts = createAction('CROP_MONITORING:SET_CROP_PROTECTION_PRODUCTS');
export const resetCropMonitoring = createAction('CROP_MONITORING:RESET');
export const setComesFromNotification = createAction('CROP_MONITORING:SET_COMES_FROM_NOTIFICATION');
